import "components/jiffy/product-details-bogo-transfers-banner/product-details-bogo-transfers-banner.scss";
import init from "components/jiffy/product-details-bogo-transfers-banner/product-details-bogo-transfers-banner";

init();
